<div class="search-box-loading">
  <div class="search-box-loading__wrapper">
    <div class="search-box-loading__content">
    </div>
  </div>
</div>
